import { useContext, useEffect } from 'react'
import { RecruitListScreenContext } from '../context'

const useRecruitListContextResetEffect = () => {
  const { dispatch } = useContext(RecruitListScreenContext)

  return useEffect(() => {
    dispatch({
      type: 'FILTER_BY_INIT',
    })
  }, [])
}

export default useRecruitListContextResetEffect
